const baseURL = "/v1/Habilidade";

const service = {
  methods: {
    $buscarHabilidades(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarHabilidades({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarHabilidade(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarHabilidade(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarHabilidade(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
